import { Partial } from '@40seas/entities/common';
import { NotificationDefinition } from './notification-definition.entity';

export class UpdateNotificationDefinitionDto extends Partial(NotificationDefinition) {}
